import { useTranslation } from "react-i18next";

const SocialProof = () => {
  const { t } = useTranslation();
  const features = [
    t("socialProof.feature1"),
    t("socialProof.feature2"),
    t("socialProof.feature3"),
    t("socialProof.feature4"),
  ];

  return (
    <section
      data-testid="social-proof-section"
      className="py-6 bg-[#2C3524] border-y border-[#C5A059]/20"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-16 gap-y-3">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-3 text-white/80 font-light text-sm md:text-base tracking-wide"
            >
              <span className="w-1 h-1 rounded-full bg-[#C5A059]" />
              {feature}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
